import React from 'react';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import {
    AddCircleOutline,
    Preview,
    Visibility,
    ShoppingBasket,
    Today,
    Grading, Home, HelpOutline,
} from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';
import { USER_ROLES } from '@shared/api/constants';

export const SecondaryListItems = ({ onClose, role }) => {
    const location = useLocation();
    const isActive = (path) => location.pathname === path;

    const renderListItem = (to, IconComponent, text) => (
        <ListItemButton
            component={Link}
            to={to}
            selected={isActive(to.slice(2))}
            onClick={onClose}
            sx={{ '&.Mui-selected': { backgroundColor: '#e0e0e0' } }}
        >
            <ListItemIcon>
                <IconComponent color="primary"/>
            </ListItemIcon>
            <ListItemText primary={text.toLowerCase()}/>
        </ListItemButton>
    );

    if (role === USER_ROLES.ROASTER)
        return (
            <>
                {renderListItem('../', Home, 'home')}
                {renderListItem('../roasting-plan', Today, 'roasting plan')}
                {renderListItem('../batches', Visibility, 'batches')}
                {renderListItem('../batches-completed', Visibility, 'roast batches')}
            </>
        );

    if (role === USER_ROLES.INVENTOR)
        return (
            <>
                {renderListItem('../add-bags', AddCircleOutline, 'add bags')}
                {renderListItem('../bags', Preview, 'bags')}
            </>
        );

    if (role === USER_ROLES.PICKER)
        return (
            <>
                {renderListItem('../packs', ShoppingBasket, 'packs')}
                {renderListItem('../orders', Grading, 'orders')}
            </>
        );

    if (role === USER_ROLES.ADMIN)
        return (
            <>
                {renderListItem('../', Home, 'home')}
                {renderListItem('../roasting-plan', Today, 'roasting plan')}
                {renderListItem('../add-bags', AddCircleOutline, 'add bags')}
                {renderListItem('../bags', Preview, 'bags')}
                {renderListItem('../batches', Visibility, 'batches')}
                {renderListItem('../batches-completed', Visibility, 'roast batches')}
                {renderListItem('../add-pack', ShoppingBasket, 'add pack')}
                {renderListItem('../packs', ShoppingBasket, 'packs')}
                {renderListItem('../orders', Grading, 'orders')}
                {!onClose || renderListItem('../documentation', HelpOutline, 'documentation')}
            </>
        );

    return null;
};
